import {createApp} from "vue";
import { useVuelidate } from "@vuelidate/core";
import { createGtm } from "@gtm-support/vue-gtm";
import Axios, { userSessionName, apiApp } from "./js/axios";
import moment from "moment";

import App from "./App.vue";

import Session from "./plugins/Session.js";
import AccessControl from "./plugins/AccessControl.js";
import Utilities from "./plugins/Utilities.js";
import HTTPUtilities from "./plugins/HTTPUtilities.js";
import SignalRConnector from "./plugins/SignalRConnector.js";
import router from "./router.js";
import vuetify from "./plugins/Vuetify";
import { setAppGlobals } from '@/plugins/appGlobals';

const app = createApp(App);

app.use(router);
app.use(vuetify); 

app.use(
  createGtm({
    id: process.env.VUE_APP_GTM_ID, 
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: "2726c7f26c", // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
  })
);

Session(app);
Utilities(app);
AccessControl(app);
SignalRConnector(app);
HTTPUtilities(app);

app.config.globalProperties.$axios = Axios;
app.config.globalProperties.$routes = router;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$userSessionName = userSessionName;
app.config.globalProperties.$api_web = process.env.VUE_APP_API_WEB;
app.config.globalProperties.$api_app = apiApp;
app.config.globalProperties.$app_version = process.env.VUE_APP_VERSION;
app.config.globalProperties.$notRequiredAuth = [
  "login",
  "terms",
  "forgotPassword",
  "createPassword",
  "recoverPassword",
  "resetPassword",
  "resetAppPassword",
  "unsubscribeNewsletter"
];
app.config.globalProperties.$hasDoctorBg = [
  "whoWeAre"
];

// TODO: Embed this into SFC
require("./assets/css/main.css");

// TODO: Remove this, convert to composable
app.mixin({
  data(){
    return {
      v: useVuelidate(),
      loggedUser: {

      }
    };
  },

  methods:{
    updateUserData(){

    },
    deleteUserData(){

    }
  }
});

setAppGlobals(app);

app.mount("#app");

export default app;